import { createContext } from 'react';
import { ChatContextData } from './interfaces/chat-context-props.interface';

const ChatContext = createContext<ChatContextData>({} as ChatContextData);

export default ChatContext;
